// ** Third Party Components
import classnames from 'classnames';
import React, { Fragment } from 'react';

const LayoutWrapper = (props) => {
  // ** Props
  const { children, wrapperClass, routerProps } = props;
  return <>{children}</>;
};

export default LayoutWrapper;
